export enum ReferralQuestionKind {
  TextSingleLine = 'string',
  TextMultiLine = 'text',
  SingleRadio = 'boolean',
  MultiRadio = 'single_choice',
  Checkbox = 'multi_choice',
  Dropdown = 'dropdown',
}

export type TReferralQuestionKind =
  | 'string'
  | 'text'
  | 'boolean'
  | 'single_choice'
  | 'multi_choice'
  | 'dropdown';

export enum ReferralTermKind {
  PrivacyPolicy = 'privacy_policy',
  TermsConditions = 'terms_&_conditions',
}
